module.exports = __webpack_public_path__ + "static/media/natours.ebde38bb.JPG";